import type { UseMutationOptions } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import type { BffStockNotificationBody } from '@/core/models/bff-catalog';
import { createBffStockNotification } from '@/core/services/fetchers';

export const MUTATION_KEY = ['bff-create-stock-notification'];

export type Variables = {
  productId: string;
  countryCode: string;
  languageCode?: string;
  emailAddress: string;
};

async function mutationFn(variables: Variables): Promise<void> {
  const body: BffStockNotificationBody = {
    countryCode: variables.countryCode,
    languageCode: variables.languageCode ?? 'en',
    emailAddress: variables.emailAddress,
  };
  await createBffStockNotification(variables.productId, body);
}

const useBffStockNotificationMutation = (
  options?: Omit<
    UseMutationOptions<void, Error, Variables>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation({
    ...options,
    mutationKey: MUTATION_KEY,
    mutationFn: (variables: Variables) => mutationFn(variables),
  });

export default useBffStockNotificationMutation;
